import _ from "lodash";
import {
  admin_data,
  csm_data,
  lab_admin,
  tenant_admin,
  tenant_admin_noworkspace,
  tenant_user,
  tenant_user_portal,
  tenant_user_workspace_and_portal,
  b2c_end_user,
} from "../components/common/sidebar/sidebarMenus";
import { roleName, tenantServicesMap } from "../constants/componentConstants";
import { localStorageHelper } from "./storageHelper";
import { workspaceMenu } from "../components/common/sidebar/sidebarMenus";

export const routeMapperFunction = (data) => {
  let routeArr = [];
  data.forEach((ele) => {
    if (ele?.permissions?.length > 0 && ele?.permissions?.includes("list")) {
      let obj = {
        ...ele,
        key: ele?.resource_path?.replace("/v1/", ""),
      };
      routeArr.push(obj);
    }
  });

  //Added temp code for role based feature for Demo
  const roleList = JSON.parse(localStorageHelper.get("role_name"));
  const isMarkForB2c = localStorageHelper.get("is_mark_for_b2c");
  const b2cUser = isMarkForB2c !== "undefined" ? JSON.parse(isMarkForB2c) : false;
  const tenant_services = JSON.parse(localStorageHelper.get("tenant_services"));
  let sideBarOptions = tenant_user_workspace_and_portal;
  if (tenant_services === tenantServicesMap?.portalLogin) {
    sideBarOptions = tenant_user_portal;
  } else if (tenant_services === tenantServicesMap?.both) {
    sideBarOptions = tenant_user_workspace_and_portal;
  }
  switch (roleList[0]) {
    case roleName.tenantUser:
      if (b2cUser) {
        return addSubMenus(routeArr, b2c_end_user);
      } else return addSubMenus(routeArr, sideBarOptions);
    case roleName.labadmin:
      return addSubMenus(routeArr, lab_admin);
    case roleName.csmadmin:
      return addSubMenus(routeArr, csm_data);
    case roleName.tenantadmin:
      const isMentor = JSON.parse(localStorageHelper.get("is_mentor") || "false");
      if (isMentor) {
        return addSubMenus(routeArr, [workspaceMenu]);
      }
      return JSON.parse(localStorageHelper.get("tenant_services")) === tenantServicesMap?.both
        ? addSubMenus(routeArr, tenant_admin)
        : addSubMenus(routeArr, tenant_admin_noworkspace);
    default:
      return addSubMenus(routeArr, admin_data);
  }
};

export const addSubMenus = (routeArr, subMenuArr) => {
  let menuArr = [];
  menuArr.push(subMenuArr?.[0]);
  subMenuArr.forEach((menu) => {
    routeArr.forEach((route) => {
      if (route.key === menu.key) {
        menuArr.push(menu);
      }
    });
  });
  return menuArr;
};

export const checkUserAccess = (routeArr, url) => {
  let checkFlag = false;
  let pathArr = _.map(routeArr, "path");
  pathArr.forEach((route) => {
    if (url[1].includes(route?.replace("/", ""))) {
      checkFlag = true;
    }
  });
  return checkFlag;
};
